export class AwsDynamoDbResource {
    'billingMode';
    'readCapacityUnits';
    'writeCapacityUnits';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "billingMode",
            "baseName": "billingMode",
            "type": "DynamoDbBillingMode",
            "format": ""
        },
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbResource.attributeTypeMap;
    }
    constructor() {
    }
}
